import React from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';

import ScreenWrapper from '../features/Theme/ScreenWrapper';
import StrategyDetails from '../features/AIStrategies/StrategyDetails';

export default function AIStrategyDetailsScreen() {
    const navigation = useNavigation<any>();
    const route = useRoute<any>();
    const strategyId: string = route.params?.strategyId;

    return (
        <ScreenWrapper>
            {/* Keyed per id: a completion-popup tap can update this route's params in place,
                and the detail screen holds per-strategy state (strategy, progress, in-flight
                loads) that must not leak from one id to the next. */}
            <StrategyDetails
                key={strategyId}
                strategyId={strategyId}
                onExit={() => navigation.goBack()}
                // navigate(), not goBack(): this detail is often the first route on its stack
                // (its URL is deep-linkable), and goBack() there bubbles up to the bottom-tab
                // navigator and lands the user on another tab.
                onOpenList={() => navigation.navigate('AIStrategiesList')}
                onClone={(id) => navigation.navigate('CreateAIStrategy', { cloneStrategyId: id })}
            />
        </ScreenWrapper>
    );
}
